module.exports = __webpack_public_path__ + "img/3-bottom.fc1eb3ba.png";